import {Component, signal} from '@angular/core';
import { AsyncPipe, KeyValuePipe } from '@angular/common';
import {BehaviorSubject} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {PopoverData} from '../../classes/popover-data';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'tgrid-layer-popup',
  imports: [
    AsyncPipe,
    KeyValuePipe,
    MatIconModule,
    MatTooltipModule,
],
  templateUrl: './layer-popup.component.html',
  standalone: true,
  styleUrl: './layer-popup.component.scss',
})
export class LayerPopupComponent {

  public subjectData: BehaviorSubject<Map<string, PopoverData[]>> = new BehaviorSubject<Map<string, PopoverData[]>>(new Map());
  protected popoverData = signal(false);

  constructor() {
    this.subjectData.pipe(takeUntilDestroyed())
      .subscribe(d => {
        this.popoverData.set(d.size !== 0);
      });
  }

}
